import React, {useState, useEffect} from 'react';

import getChangelogs from '../../changeLogs/all-changelogs'

function ClientViewPageUpdateModal({visible, setVisible}) {
    const client_version = process.env.REACT_APP_CLIENT_VERSION;

    const [progress, setProgress] = useState(0);
    const [isDownloading, setIsDownloading] = useState(false);
    const [canInstall, setCanInstall] = useState(false)

    const [showAlertERROR, setShowAlertERROR] = useState(false)
    const [ERRORAlertText, setERRORAlertText] = useState("")

    const [updateInfo, setUpdateInfo] = useState({status: "success", size_mb: 0, ping_ms: 0, highlights: "Loading..."});

    const handleOpenChangelogs = () => {
        if (window.pywebview?.api?.open_changelogs_page) {
            window.pywebview.api.open_changelogs_page();
        }
    };

    const handleClose = () => {
        setVisible(false)
    }

    const showAlert = (type, text) => {
        if (type === "error") {
            setShowAlertERROR(true)
            setERRORAlertText(text)

            setTimeout(function() {
                setShowAlertERROR(false)
            }, 3500)
        }
    }

    useEffect(() => {
        async function fetchInfo() {
            const info = await window.pywebview.api.get_update_info("https://live-telemetry.gmigliaro.it/downloads/updates/LiveTelemetry.exe");

            if (info.status === "success") {
                const CHANGELOGS = getChangelogs();

                CHANGELOGS.forEach(version => {
                    if (version.release === "Current Release") {
                        info.highlights = version.highlights
                    }
                });

                setUpdateInfo(info);
            } else {
                showAlert("error", info.message)
            }
        }

        fetchInfo();
    }, []);

    useEffect(() => {
        async function verifyFile() {
            const url = "https://live-telemetry.gmigliaro.it/downloads/updates/LiveTelemetry.exe";
            const exists = await window.pywebview.api.check_if_installer_exists(url);
            
            if (exists) {
                setIsDownloading(true);
                setCanInstall(true)
                setProgress(100);
            }
        }
        verifyFile();
    }, []);

    useEffect(() => {
        window.updateDownloadProgress = (p) => {
            setProgress(p);
            if (p === 100) setCanInstall(true);
        };

        return () => delete window.updateDownloadProgress;
    }, []);

    useEffect(() => {
        window.onUpdateError = (errorMsg) => {
            showAlert("error", errorMsg)
            setIsDownloading(false);
            setCanInstall(false)
            setProgress(0);
        };
    }, []);

    const handleStartUpdate = async () => {
        try {
            setIsDownloading(true);
            await window.pywebview.api.start_update("https://live-telemetry.gmigliaro.it/downloads/updates/LiveTelemetry.exe"); 
        } catch (errorMsg) {
            showAlert("error", errorMsg)
            setIsDownloading(false);
        }
    };

    const handleStartInstall = async () => {
        try {
            await window.pywebview.api.install_update();
        } catch (errorMsg) {
            showAlert("error", errorMsg)
        }
    };

    return (
        <>
            {visible === true &&
                <div className={`fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm px-4`}>
                    <div className="w-full max-w-[440px] bg-white dark:bg-[#111a22] rounded-xl shadow-[0_20px_50px_rgba(0,0,0,0.5)] border border-slate-200 dark:border-slate-800 overflow-hidden relative rounded-xl">
                        <button onClick={() => handleClose()} className={`absolute top-4 right-4 z-10 text-white/70 hover:text-white transition-colors`} style={{width: "fit-content", height: "fit-content"}}>
                            <span className="material-symbols-outlined">close</span>
                        </button>

                        <div className="h-24 bg-primary relative">
                            <div className="absolute inset-0 opacity-20" style={{backgroundImage: "linear-gradient(45deg, #000 25%, transparent 25%, transparent 50%, #000 50%, #000 75%, transparent 75%, transparent)", backgroundSize: "20px 20px"}}></div>
                            <div className="absolute inset-0 bg-gradient-to-t from-[#111a22] to-transparent"></div>
                            <div className="absolute -bottom-6 left-6 size-12 bg-primary rounded-lg flex items-center justify-center text-white shadow-lg shadow-primary/40 ring-4 ring-[#111a22]">
                                <span className="material-symbols-outlined text-3xl">system_update</span>
                            </div>
                        </div>

                        <div className="p-6 pt-10">
                            <div className="flex items-center justify-between mb-2">
                                <h3 className="text-xl font-bold text-slate-900 dark:text-white font-display">System Update Ready</h3>
                                <span className="bg-primary/10 text-primary text-[10px] font-bold uppercase tracking-widest px-2 py-0.5 rounded border border-primary/20">Stable</span>
                            </div>
                            <div className="flex items-center gap-2 mb-4">
                                <p className="text-slate-600 dark:text-slate-400 text-sm">New Update Available:</p>
                                <span className="text-slate-900 dark:text-white text-sm font-bold bg-slate-100 dark:bg-slate-800 px-2 py-0.5 rounded">v{client_version}</span>
                            </div>
                            <div className="bg-slate-50 dark:bg-slate-800/30 rounded-lg p-4 mb-6">
                                <div className="flex gap-3">
                                    <span className="material-symbols-outlined text-primary text-xl">speed</span>
                                    <div>
                                        <p className="text-xs font-bold text-slate-400 uppercase tracking-tight mb-1">Release Highlights</p>
                                        <p className="text-sm text-slate-600 dark:text-slate-300 leading-relaxed">
                                            {updateInfo.highlights}
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div className="grid grid-cols-2 gap-4 mb-8 border-y border-slate-100 dark:border-slate-800 py-4">
                                <div>
                                    <p className="text-[10px] text-slate-400 uppercase font-bold tracking-widest mb-1">Download Size</p>
                                    <p className="text-sm font-medium dark:text-slate-200">{updateInfo.size_mb} MB</p>
                                </div>
                                <div>
                                    <p className="text-[10px] text-slate-400 uppercase font-bold tracking-widest mb-1">Server latency</p>
                                    <p className="text-sm font-medium dark:text-slate-200">~ {updateInfo.ping_ms} ms</p>
                                </div>
                            </div>

                            <div className="flex flex-col gap-3">
                                {isDownloading === false ? (
                                    <button onClick={() => handleStartUpdate()} className="w-full bg-primary hover:bg-primary/90 text-white font-bold py-3.5 rounded-lg flex items-center justify-center gap-2 transition-all active:scale-[0.98] shadow-lg shadow-primary/25">
                                        <span className="material-symbols-outlined">download</span>
                                        Download Update
                                    </button>

                                    ) : progress !== 100 ? (
                                        <div className="w-full space-y-2 mb-2">
                                            <div className="flex justify-between items-center text-xs font-bold uppercase tracking-widest">
                                                <span className="text-primary flex items-center gap-2">
                                                    <span className="animate-pulse size-1.5 rounded-full bg-primary"></span>
                                                    Downloading Update...
                                                </span>
                                                <span className="text-slate-900 dark:text-white">{progress}%</span>
                                            </div>

                                            <div className="w-full h-3 bg-slate-100 dark:bg-slate-800 rounded-full overflow-hidden border border-slate-200 dark:border-slate-700 p-0.5">
                                                <div className="h-full bg-primary rounded-full shadow-[0_0_10px_rgba(19,127,236,0.5)] transition-all duration-100" style={{ width: `${progress}%` }}></div>
                                            </div>
                                        </div>

                                    ) : canInstall && (
                                        <button onClick={() => handleStartInstall()} className="w-full bg-primary hover:bg-primary/90 text-white font-bold py-3.5 rounded-lg flex items-center justify-center gap-2 transition-all active:scale-[0.98] shadow-lg shadow-primary/25">
                                            <span className="material-symbols-outlined">download</span>
                                            Install Update
                                        </button>
                                )}

                                {window.pywebview?.api?.open_changelogs_page && (
                                    <button onClick={() => handleOpenChangelogs()} className="w-full bg-transparent hover:bg-slate-100 dark:hover:bg-slate-800 text-slate-500 dark:text-slate-400 hover:text-slate-900 dark:hover:text-white font-semibold py-3 rounded-lg text-sm transition-colors flex items-center justify-center gap-2">
                                        View Detailed Changelogs
                                        <span className="material-symbols-outlined text-sm">open_in_new</span>
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            }

            {showAlertERROR && <span className="flex px-5 py-2 rounded-xl fixed z-[999] bg-alert-red text-sm right-[10px] top-[35px] select-none animate-[show-alert_3s_ease-in-out_forwards]">{ERRORAlertText}</span>}
        </>
    );
}


export default ClientViewPageUpdateModal;